import { API_STATES } from "@/helpers";

const state = {
  taskCategoriesGetState  : API_STATES.NOT_REQUESTED,
  taskCategoriesGetError  : null,
  taskCategoryDeleteState : API_STATES.NOT_REQUESTED,
  taskCategoryDeleteError : null,
  taskCategories          : [],
  taskCategoryCreateState : API_STATES.NOT_REQUESTED,
  taskCategoryCreateError : null,
  taskCategoryUpdateState : API_STATES.NOT_REQUESTED,
  taskCategoryUpdateError : null,
  taskCategory            : {},
};

export default state;